import { createContext, useContext } from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { APP_NAME } from "@/config";

// The Graphite design system, page by page: a page that has moved renders inside <GraphiteScope>. The scope
// switches the colours (the .graphite tokens in index.css) and tells the ui/ buttons, inputs, labels and
// checkboxes to draw Graphite's shapes and type. Once every page has moved, this becomes the default.
const GraphiteContext = createContext(false);
export const useGraphite = () => useContext(GraphiteContext);

export function GraphiteScope({ className, children, ...props }) {
  return (
    <GraphiteContext.Provider value={true}>
      <div className={cn("graphite", className)} {...props}>{children}</div>
    </GraphiteContext.Provider>
  );
}

// The mark and the name, in the display face at 24px (Graphite ships no logo)
export function Wordmark({ to }) {
  const mark = (
    <>
      <div className="w-7 h-7 rounded-md bg-primary text-primary-foreground grid place-items-center font-display font-bold text-base">C</div>
      <span className="font-display font-semibold text-2xl tracking-[0.02em]">{APP_NAME}</span>
    </>
  );
  return to ? <Link to={to} className="flex items-center gap-3">{mark}</Link> : <div className="flex items-center gap-3">{mark}</div>;
}
